import ContactSalesNotice from '../../components/ContactSalesNotice';
import { selectProfile } from '../../../../../store/workspace/selectors';
import PriceSummary from '../../components/PriceSummary';
import { useDispatch, useSelector } from '../../../../../store/store';
import { InviteMemberIcon } from '../../../../../assets/icons';
import { ExtraServiceOption } from '../../types';
import DropDown from '../../../../../components/DropDown';
import { useMemo, useState } from 'react';
import styles from './style.module.scss';
import Modal from '../../../../../components/Modal';
import {
    JOB_POST_OPTIONS,
    FALLBACK_PLAN_TYPE,
    JOB_POST_UNIT_PRICES,
    APPLICANTS_PER_JOB_POST,
} from '../../constants';
import {
    setExtraServiceDetail,
    setAddExtraJobPostModal,
    setExtraServicesPaymentModal,
} from '../../../../../store/workspace/slice';

export default function AddExtraJobPost() {
    const dispatch = useDispatch();
    const profile = useSelector(selectProfile);
    const planType = profile?.planType || FALLBACK_PLAN_TYPE;
    const unitPrice = JOB_POST_UNIT_PRICES[planType];
    const applicantsPerPost = APPLICANTS_PER_JOB_POST[planType];
    const [selectedOption, setSelectedOption] = useState<ExtraServiceOption | null>(null);
    const needsSales = Boolean(selectedOption?.contactSales);

    /** How many applicants a bundle carries depends on the plan, so labels are built here. */
    const options = useMemo(() => JOB_POST_OPTIONS.map(option => {
        const applicants = option.contactSales ? '' : `+ ${option.sub * applicantsPerPost} Applicants`;
        return { ...option, title: `${option.title} ${applicants}` };
    }), [applicantsPerPost]);

    const closeModal = () => dispatch(setAddExtraJobPostModal(false));

    const submit = () => {
        if (!selectedOption) return;

        dispatch(setExtraServiceDetail({
            type: 'job',
            sub: selectedOption.sub,
        }));

        closeModal();
        dispatch(setExtraServicesPaymentModal(true));
    };

    return (
        <Modal
            size='md'
            actions='both'
            title='Add job post'
            closeFunc={closeModal}
            icon={<InviteMemberIcon />}
            childClassName={styles.wrapper}
            dismissButton={{
                text: 'Cancel',
                type: 'Outline-Dark',
                onClick: closeModal,
            }}
            confirmButton={{
                text: 'pay',
                type: 'Primary',
                onClick: submit,
                disabled: !selectedOption || needsSales,
            }}
        >
            <h6>To add more, an additional job post charge applies.</h6>

            <DropDown
                idKey='id'
                titleKey='title'
                dropDownList={options}
                selectedItem={selectedOption}
                setItem={setSelectedOption}
            />

            {!needsSales && <PriceSummary
                breakdown={`$${unitPrice} Per 1 Job Post + ${(selectedOption?.sub || 0) * applicantsPerPost} Applicants`}
                total={(selectedOption?.sub || 0) * unitPrice}
            />}

            {needsSales && <ContactSalesNotice
                text='For more than 1000 applicants you should contact sales!'
            />}
        </Modal>
    );
};
